import React, { useState } from "react";
import { Link, scroller } from "react-scroll";
import { FaBars } from "react-icons/fa";
import Logo from "./Logo";

function Navbar() {
  const [open, setOpen] = useState(false);

  const goContact = () => {
    setOpen(false);
    scroller.scrollTo("contact", { smooth: true, duration: 550, offset: -96 });
  };

  return (
    <header className="site-header">
      <nav className="navbar" aria-label="Navigimi kryesor">
        <div className="navbar-inner container">
          <Link
            to="home"
            smooth={true}
            duration={500}
            offset={-96}
            className="brand-link"
            aria-label="TechTalent, kthehu në krye"
          >
            <Logo />
          </Link>

          <button
            type="button"
            className="menu-icon"
            onClick={() => setOpen((prev) => !prev)}
            aria-label={open ? "Mbyll menunë" : "Hap menunë"}
            aria-expanded={open}
          >
            <FaBars />
          </button>

          <ul className={open ? "nav-links active" : "nav-links"}>
            <li>
              <Link
                className="nav-link"
                to="services"
                smooth={true}
                duration={500}
                offset={-96}
                onClick={() => setOpen(false)}
              >
                Shërbimet
              </Link>
            </li>
            <li>
              <Link
                className="nav-link"
                to="approach"
                smooth={true}
                duration={500}
                offset={-96}
                onClick={() => setOpen(false)}
              >
                Qasja
              </Link>
            </li>
            <li>
              <Link
                className="nav-link"
                to="projects"
                smooth={true}
                duration={500}
                offset={-96}
                onClick={() => setOpen(false)}
              >
                Punët
              </Link>
            </li>
            <li>
              <Link
                className="nav-link"
                to="testimonials"
                smooth={true}
                duration={500}
                offset={-96}
                onClick={() => setOpen(false)}
              >
                Klientët
              </Link>
            </li>
            <li>
              <Link
                className="nav-link"
                to="team"
                smooth={true}
                duration={500}
                offset={-96}
                onClick={() => setOpen(false)}
              >
                Ekipi
              </Link>
            </li>
            <li>
              <Link
                className="nav-link"
                to="contact"
                smooth={true}
                duration={500}
                offset={-96}
                onClick={() => setOpen(false)}
              >
                Kontakt
              </Link>
            </li>
            <li className="nav-cta-wrap">
              <button type="button" className="nav-cta" onClick={goContact}>
                Cakto konsultë fillestare
              </button>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;
